// extracted by mini-css-extract-plugin
export default {"story_container":"styles_story_container__uS2A5","story_heading":"styles_story_heading__YH0ep"};